import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Facebook = createIcon({
  displayName: "Facebook",
  viewBox: "0 0 32 32",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title>Facebook Icon</title>
      <path
        fill="currentColor"
        d="M21.0772 17.5L21.7351 13.1875H17.5527V10.375C17.5527 9.15625 18.1166 8.03125 19.9964 8.03125H21.9231V4.32812C21.9231 4.32812 20.1843 4 18.5396 4C15.1091 4 12.8534 6.10938 12.8534 9.85938V13.1875H9V17.5H12.8534V28H17.5527V17.5H21.0772Z"
      />
    </>
  )
});
